import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { copyTextToClipboard } from '../../helpers/copyTextToClipboard';
import { Icon } from '../Icon/Icon';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';
import { FlexContainer } from '../layout/FlexContainer';
export const CopyableTextWithTooltip = ({ children, testId, onCopySuccess, onCopyError, tooltipText, ...textProps }) => {
    const handleClick = () => {
        copyTextToClipboard({ text: children, onCopySuccess, onCopyError });
    };
    return (_jsxs(FlexContainer, { verticalAlign: 'center', gap: '1/2', children: [_jsx(Tooltip, { text: tooltipText, children: _jsx(Text, { ...textProps, children: children }) }), _jsx(PlainButton, { testId: testId, onClick: handleClick, children: _jsx(Icon, { name: 'OutlineContentCopy', size: 'small', color: 'greyLight' }) })] }));
};
